import { requester } from '../utils';

export const getCafesContract = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-contract?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const insertNewCafeContract = cafeContractObject => {
  return new Promise((resolve, reject) => {
    console.log('newCafeContract', cafeContractObject);
    requester
      .fetchAPI({
        route: `v1/cafe-contract`,
        method: 'POST',
        data: cafeContractObject,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getCitiesContract = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/city/names`,
        // route: `v1/general/cities`,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const getCityContract = cityCode => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/city/byCode/${cityCode}`,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getContractById = contractId => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-contract/${contractId}`,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updateCafeContract = cafeContractObject => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-contract`,
        method: 'PUT',
        data: cafeContractObject,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
